import React, {Component} from 'react'
import {Map, Marker, TileLayer, ZoomControl} from 'react-leaflet';
import {divIcon} from 'leaflet';

class IGNMap extends Component {

    constructor(props) {
        super(props)
        this.state = {
            map: null,
            viewport: {
                center: [30, 5],
                zoom: 7
            }
        }
    }

    componentDidMount() {
        this.setState({
            viewport: {
                center: this.props.center,
                zoom: parseInt(this.props.zoom)
            }
        })
    }

    onViewportChanged(viewport) {
        this.setState({viewport})
    }

    componentDidUpdate() {
        Array.from(document.querySelectorAll('.leaflet-control-attribution a')).forEach((el) => {
            el.setAttribute('target', '_blank')
        })
    }

    render() {
        const MapUrl = `https://data.geopf.fr/wmts?service=WMTS&request=GetTile&version=1.0.0&tilematrixset=PM&tilematrix={z}&tilecol={x}&tilerow={y}&layer=GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2&format=image/png&style=normal`

        const LeafletMap = (
            <Map ref="map"
                 zoomControl={false}
                 doubleClickZoom={false}
                 scrollWheelZoom={false}
                 dragging={true}
                 style={{"height": "100%", "width": "100%"}}
                 viewport={this.state.viewport}
                 minZoom={2.5}
                 maxZoom={18}
                 onViewportChanged={this.onViewportChanged.bind(this)}
            >
                <TileLayer
                    noWrap={true}
                    attribution={`<a href="http://www.ign.fr/" target="_blank" onclick="dataLayer.push({
                          event: 'clic-IGN-logo',
                          eventLabel: 'http://www.ign.fr',
                          eventAction: 'Logo_IGN',
                          eventCategory: 'Navigation'
                        })"><img src="/data/images/map/ign-logo.png" loading="lazy" width="40px" height="20px" /></a>`}
                    url={MapUrl}
                />
                <Marker icon={divIcon({
                    html: '<img class="leaflet-marker-skinned" alt="marker" src="/data/images/map/marker-map.png" loading="lazy">'
                })} position={this.props.center}>
                </Marker>
                <ZoomControl position="bottomleft"/>
            </Map>
        )

        return (
            <div className="leaflet-map-container">
                {LeafletMap}
            </div>
        )
    }
}

export default (IGNMap)


// WEBPACK FOOTER //
// ./resources/assets/frontend/js/components/IgnMap.js